export const DEFAULT_SIDENAV_COLLAPSED_STATE = true;
